import { Button, Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';

import React, { FC, useState } from 'react';
import { useStyles } from './styles';
import Documents from '@public/pages/Documents';
import project, { isSpecialBilling } from '@constants/project';
import { MINIO_END_POINT } from '@core/constants/minio';

type Props = {
  setPolicyModalAgreement: (policyModalAgreement: string | null) => void;
};

const consentDocument = {
  title: 'Согласие на обработку персональных данных',
  fileName: 'personal_data_processing_agreement.pdf',
};

const documentUri = (fileName: string): string =>
  `${MINIO_END_POINT}/${
    isSpecialBilling ? 'billing' : project
  }/notsecured/00000000-0000-0000-0000-000000000000/${fileName}#toolbar=0&navpanes=0&scrollbar=0`;

const PolicyModalAgreement: FC<Props> = ({ setPolicyModalAgreement }) => {
  const classes = useStyles();
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const [openConsent, setOpenConsent] = useState(false);

  const handleUpdateLocalStoragePolicyModalAgreement = () => {
    localStorage.setItem('PolicyModalAgreement', 'agreement');
    setPolicyModalAgreement('agreement');
  };

  return (
    <>
      <Grid
        style={{
          backgroundColor: '#07003D',
          padding: isXs ? '10px' : '25px 53px',
          borderRadius: 8,
          width: isXs ? '90%' : '80%',
          margin: isXs ? '20px auto' : '0 auto',
          position: 'fixed',
          bottom: '20px',
          display: 'flex',
          flexDirection: isXs ? 'column' : 'row',
          justifyItems: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          gap: isXs ? 10 : 20,
          maxWidth: '1300px',
          minHeight: '126px',
          height: 'max-content',
          boxSizing: 'border-box',
          zIndex: 1300,
          marginTop: '20px',
          left: 0,
          right: 0,
        }}
      >
        <div className={classes.content}>
          <Typography
            style={{
              color: 'white',
              fontSize: isXs ? 16 : 20,
              lineHeight: isXs ? '20px' : '24px',
              fontWeight: 600,
              textAlign: isXs ? 'center' : 'left',
              marginBottom: 8,
            }}
          >
            Мы используем файлы cookie
          </Typography>
          <Typography
            style={{
              color: 'white',
              fontSize: isXs ? 15 : 18,
              lineHeight: isXs ? '17px' : '20px',
              fontWeight: 400,
              textAlign: isXs ? 'center' : 'left',
            }}
          >
            Мы используем cookie и электронные данные для улучшения работы сайта, персонализации, в
            том числе с использованием сервиса «Яндекс.Метрика». Оставаясь на нашем портале, Вы
            выражаете свое{' '}
            <span className={classes.userLicenseLink} onClick={() => setOpenConsent(true)}>
              согласие
            </span>{' '}
            на обработку Ваших данных указанным сервисом и файлов cookie. Запретить обработку
            cookies можно в настройках вашего браузера
          </Typography>
        </div>
        <Button
          style={{
            padding: '5px 10px',
            width: isXs ? '130px' : '170px',
            minWidth: isXs ? '130px' : '170px',
            height: isXs ? '35px' : '40px',
            fontSize: isXs ? 15 : 18,
          }}
          variant="contained"
          color="primary"
          onClick={handleUpdateLocalStoragePolicyModalAgreement}
        >
          Принять
        </Button>
      </Grid>
      <Documents
        open={openConsent}
        setOpen={setOpenConsent}
        title={consentDocument.title}
        uri={documentUri(consentDocument.fileName)}
      />
    </>
  );
};

export default PolicyModalAgreement;
